import { Injectable } from '@angular/core';
import { Subject, Observable, of } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { ConfigurationService } from './configuration.service';
import { NotifMessageService } from './notifmessage.service';
import * as moment from 'moment';
import { PaymentMeansByPeriod } from '../models/paymentMeansByPeriod';
import { catchError } from 'rxjs/operators';
import { WalletsByPeriod } from '../models/walletsByPeriod';
import { UtilsService } from './utils.service';

@Injectable({
  providedIn: 'root'
})
export class MetaWalletReportingService {
  metaWalletReportingSubject = new Subject<any[]>();
  metaWalletReportingSubject$ = this.metaWalletReportingSubject.asObservable();

  constructor(private http: HttpClient,
    private configService: ConfigurationService,
    private notifService: NotifMessageService,
    private utilsService:UtilsService) { }

  saveSubject = new Subject<any[]>();

  pmUrl = "/paymentMean";
  walletUrl = "/wallet";
  getNumberOfPmByPeriod(criteria): Observable<any> {
    this.utilsService.updateCriteriaWindow(criteria);

    return this.http.get<PaymentMeansByPeriod>(this.configService.config.urlAPI.urlMetaWallet + this.pmUrl, { params: criteria }).pipe(catchError(err => {
      console.log("error getNumberOfPmByPeriod", err);
      this.notifService.notifyErrorWithDetailFromApi('ERROR_META_WALLET_API', err);
      return of(null);
    }));
  }

  getNumberOfNewWalletByPeriod(criteria): Observable<any> {
    this.utilsService.updateCriteriaWindow(criteria);

    return this.http.get<WalletsByPeriod>(this.configService.config.urlAPI.urlMetaWallet + this.walletUrl, { params: criteria }).pipe(catchError(err => {
      console.log("error getNumberOfNewWalletByPeriod", err);
      this.notifService.notifyErrorWithDetailFromApi('ERROR_META_WALLET_API', err);
      return of(null);
    }));
  }
}
